var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-widget"},[_c('schedule-calendar',{attrs:{"selected-date-parent":_vm.selectedDate,"offers":_vm.offers},on:{"date-changed":function($event){return _vm.clickDate($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }